import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CoreUiModule } from '../../core-ui/core-ui.module';
import {
    RegisterColumnDirective,
    ShowColumnDirective
} from './ColumnDefinition.component';
import { NewTableIconComponent } from './NewIcon.component';
import { NewTableJobLinkComponent } from './NewJobLink.component';
import { TableComponent } from './NewTable.component';
import { NewTableGlobalSelectComponent } from './NewTableGlobalSelect.component';
import { NewTableLinkComponent } from './NewTableLink.component';
import { SortableHeaderComponent } from './SortableHeader.component';

export const Components = [
    TableComponent,
    NewTableJobLinkComponent,
    NewTableIconComponent,
    NewTableGlobalSelectComponent,
    NewTableLinkComponent,
    RegisterColumnDirective,
    ShowColumnDirective,
    SortableHeaderComponent
];
@NgModule({
    imports: [CommonModule, RouterModule, FormsModule, CoreUiModule],
    declarations: [...Components],
    exports: [...Components],
    providers: []
})
export class NewTablesModule {}
